import React from "react";
import { Link, useNavigate } from "react-router-dom";

function CourseBuyCard({ courseData }) {
  const { instituteInfo, image, preview_video, category_id, programId, institute_id } = courseData || {};
  const AWS = process.env.REACT_APP_AWS_HOST;
  const token = process.env.REACT_APP_API_TOKEN;
  const LMS = process.env.REACT_APP_API_LMS;
  const studentId = sessionStorage.getItem("id");
  const studentInstituteId = sessionStorage.getItem("studentInstituteId");
  const navigate = useNavigate();

  const handleEnrollNow = async () => {
    try {
      const response = await fetch(`${LMS}/api/free-course-enroll`, {
        method: 'POST',
        headers: {
          'Authorization': token,
          'Accept': 'application/json',
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          user_id: parseInt(studentId),
          program_id: programId ,
          institute_id: studentInstituteId
        })
      });

      const data = await response.json();

      if (data.status === true || data.status === false) {
        // Store the programId in sessionStorage to expand it in MyPrograms
        sessionStorage.setItem("expandItem", programId);
        // Redirect to MyProgram page
        navigate('/my-program');
      }
    } catch (error) {
      console.error('Error enrolling in course:', error);
      // Even on error, redirect to MyProgram page
      sessionStorage.setItem("expandItem", programId);
      navigate('/my-program');
    }
  };

  return (
    <div className="col-md-4">
      <div className="card">
        <img 
          className="card-img-top img-fluid" 
          src={`${AWS}${image}` || ""} 
          alt="Card image" 
        />
        {/* <img className="card-img-top img-fluid" src="/assets/images/wealth_manager2.webp" alt="Card image" /> */}
        <div className="card-header h-25">
          <h4 className="card-title mb-0">{instituteInfo?.programTitle || "Program Title"}</h4>
        </div>
        <div className="card-body">
          <span className="badge border border-primary text-primary mb-2">{instituteInfo?.certificateType || "Certificate Type"}</span>
          <h6 className="lh-lg mb-0">
            <p className="mb-0">{instituteInfo?.institute || "Institute Name"}</p>
            <p className="mb-0 fs-6">Duration: {instituteInfo?.duration || "-"}</p>
            <p className="mb-2 fs-6">Apply By: {instituteInfo?.applyBy || "-"}</p>
          </h6>
        </div>
        <div className="card-footer">
          {/* <div className="row">
            <div className="col-md-6">
              <h4 className="mb- pt-2">
                ₹{Math.floor(instituteInfo?.price?.discounted) || "0"} 
                {instituteInfo?.price?.original && (
                  <del style={{marginLeft: "10px"}}><small className="text-muted">₹{Math.floor(instituteInfo.price.original)}</small></del>
                )}
              </h4>
            </div>
            <div className="col-md-6">
              <Link 
                to={instituteInfo?.action}
                className="btn w-100 btn-warning w-sm waves-effect waves-light"
                target="_blank"
                rel="noopener noreferrer"
              >
                Enroll Now
              </Link>
            </div>
          </div> */}
          <div className="row mt-2">
            <div className="col-md-12">
              {category_id === 6 ? (
                <button 
                  onClick={handleEnrollNow}
                  className="btn w-100 btn-primary waves-effect waves-light"
                >
                  Get Started
                </button>
              ) : (
                <Link 
                  to="/contact"
                  className="btn w-100 btn-primary waves-effect waves-light"
                >
                  Program Inquiry
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default CourseBuyCard;